import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { useGetTaxpayer } from 'app/modules/taxes/hooks/useTaxes';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContainerOmissions } from '../components/ContainerOmissions';
import { useGetNonComplianceTaxpayer } from '../hooks';

export const DetailNonComplianceTaxpayer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<Record<string, string>>();

  const { data, loading: l2, error: e2 } = useGetTaxpayer(id ?? '');
  const [{ data: omissions, loading: l3, error: e3 }] = useGetNonComplianceTaxpayer(id ?? '');

  if (l2 || e2 || l3 || e3 || l3 || !data) {
    return <></>;
  }

  const labelTIN = t('config.tin');
  const labelTaxpayer = t('collections.label.taxpayer');
  const labelNonCompliances = t('non-compliances.title.nonCompliancesTax');

  return (
    <>
      <PageTitle title={labelTaxpayer} />

      <div className="row">
        <div className="col-12 col-md-4">
          <div className="pair-name">{labelTIN}</div>
          <div className="pair-value"> {data.tin}</div>
        </div>
        <div className="col-12 col-md-8">
          <div className="pair-name">{labelTaxpayer}</div>
          <div className="pair-value"> {data.name}</div>
        </div>
      </div>
      <h1 className="mt-3">{labelNonCompliances}</h1>

      <ContainerOmissions omissions={omissions ?? []} />
      <BtnToolbar>
        <BtnGroup>
          <Button
            action={ButtonAction.return}
            variant="secondary"
            onClick={() => navigate('/non-compliances')}
          />
        </BtnGroup>
        <BtnGroup>
          <></>
        </BtnGroup>
      </BtnToolbar>
    </>
  );
};
